function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M0 3.903v233h177V70.096L110.625 3.903z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110.625 3.903v66.193H177z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F3F3F3",
  d: "M126.453 221.031c.932 0 1.764.731 1.764 1.7 0 .89-.813 1.661-1.764 1.661s-1.764-.771-1.764-1.661c-.001-.969.832-1.7 1.764-1.7zm11.16 3.361c-3.687 0-7.097-3.381-7.097-7.315 0-3.934 2.815-7.315 7.097-7.315 4.104 0 7.077 3.381 7.077 7.315.001 3.934-3.389 7.315-7.077 7.315zm0-2.254c2.419 0 4.678-2.372 4.678-5.061s-1.903-5.061-4.678-5.061c-2.795 0-4.659 2.372-4.659 5.061.001 2.689 2.261 5.061 4.659 5.061zm19.131-12.178v2.056h-4.203v12.178h-2.26v-12.178h-4.223v-2.056h10.686zm11.934 2.155h-7.632v3.697h6.463v2.155h-6.463v6.227h-2.26V209.96h9.892v2.155z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M219.424 12.199h310.775v235.826H219.424z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M207.224 0h310.775v235.826H207.224z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("text", {
  transform: "translate(35 146)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#5425E7",
  fontSize: 80
}, "Aa"));

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F3F3F3",
  d: "M226.813 0h271.094v175.724H226.813z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M241.876 31.912h181.716v114.905H241.876z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("text", {
  transform: "translate(241.875 55.381)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#5425E7",
  className: "otfLogoTextSpecimenName",
  fontSize: 32
}, "My Font"), React.createElement("tspan", {
  className: "otfLogoTextSpecimenVariant",
  x: 0,
  y: 38.4,
  fill: "#5425E7",
  fontSize: 32
}, "Regular"));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 530.199,
    height: 248.025,
    viewBox: "0 0 530.199 248.025"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/otf.1a2c4737.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/checkout/otf.svg
// module id = 522
// module chunks = 0